/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Harden_Detail6Inputs */

const en_svc_programmatic_seo_harden_detail6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitoring, refresh loops and quality gates.`)
};

const ar_svc_programmatic_seo_harden_detail6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المراقبة وحلقات التحديث وبوابات الجودة.`)
};

const bn_svc_programmatic_seo_harden_detail6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মনিটরিং, রিফ্রেশ লুপ আর মান গেট।`)
};

const de_svc_programmatic_seo_harden_detail6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitoring, Aktualisierungsschleifen und Qualitäts-Gates.`)
};

const es_svc_programmatic_seo_harden_detail6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitorización, ciclos de frescura y puertas de calidad.`)
};

const fr_svc_programmatic_seo_harden_detail6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supervision, boucles d'actualisation et portes de qualité.`)
};

const pt_svc_programmatic_seo_harden_detail6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitorização, ciclos de frescura e portas de qualidade.`)
};

const zh_svc_programmatic_seo_harden_detail6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`监控、刷新循环和质量门禁。`)
};

const tr_svc_programmatic_seo_harden_detail6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İzleme, tazelik döngüleri ve kalite kapıları.`)
};

const ru_svc_programmatic_seo_harden_detail6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мониторинг, циклы обновления и ворота качества.`)
};

const pl_svc_programmatic_seo_harden_detail6 = /** @type {(inputs: Svc_Programmatic_Seo_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitoring, pętle odświeżania i bramki jakości.`)
};

/**
* | output |
* | --- |
* | "Monitoring, refresh loops and quality gates." |
*
* @param {Svc_Programmatic_Seo_Harden_Detail6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_harden_detail6 = /** @type {((inputs?: Svc_Programmatic_Seo_Harden_Detail6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Harden_Detail6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_harden_detail6(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_harden_detail6(inputs)
	if (locale === "de") return de_svc_programmatic_seo_harden_detail6(inputs)
	if (locale === "es") return es_svc_programmatic_seo_harden_detail6(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_harden_detail6(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_harden_detail6(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_harden_detail6(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_harden_detail6(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_harden_detail6(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_harden_detail6(inputs)
	return en_svc_programmatic_seo_harden_detail6(inputs)
});
export { svc_programmatic_seo_harden_detail6 as "svc_programmatic-seo_HARDEN_detail" }